export const environment = {
  production: false,
  enableDebug: true,
  appVersion: '1.0.0',
  apiVer: '',
//  baseAPIUrl : 'http://103.89.50.112:5002/api/ver01',
  baseAPIUrl : 'https://portal-uat-api.pension.payme.com.mm/api/ver01',
 mobileAPIUrl: 'http://pension-uat.payme.com.mm:5002/api/ver02',
  // baseAPIUrl : 'https://portal-uat-api.pension.payme.com.mm/api/ver01',
  // mobileAPIUrl: 'https://mobile-uat-api.pension.payme.com.mm/api/ver02',
  // baseAPIUrl: 'https://portal-api.pension.payme.com.mm/api/ver01',
  // mobileAPIUrl: 'https://mobile-api.pension.payme.com.mm/api/ver02',
  middleWareAPIUrl: 'https://middleware-api.pension.payme.com.mm/api/ver01',
  InsID : ''
};